import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UtilService } from '../../../services/util.service';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Email } from './email';
import { DialogService } from '../../../services/dialog.service';
import { ToastService } from '../../../services/toast.service';


@Component({
  selector: 'app-contato',
  templateUrl: './contato.component.html',
  styleUrls: ['./contato.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ContatoComponent implements OnInit {
  submitted = false;
  error = '';
  loading = false;
  formContato = new UntypedFormGroup({});
  email: Email;
  constructor(
    private utilService: UtilService,
    private dialogService: DialogService,
    private toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.createForm(new Email());
  }

  createForm(linkForm: Email) {
    this.formContato = new UntypedFormGroup({
      emailFrom: new UntypedFormControl(linkForm.emailFrom, [
        Validators.required,
        Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
      ]),
      assunto: new UntypedFormControl(linkForm.assunto, Validators.required),
      mensagem: new UntypedFormControl(linkForm.mensagem, Validators.required),
    });
  }

  get f() {
    return this.formContato.controls;
  }

  submitForm() {
    this.submitted = true;

    if (this.formContato.invalid) {
      this.error = 'Informações inválidas';
      return;
    }
    this.loading = true;
    this.email = this.formContato.value;
    this.utilService.sendEmail(this.email).subscribe(
      (res) => {
        this.toastService.show('Contato enviado com sucesso! Breve responderei!', { type: 'success' });
        this.createForm(new Email());
        this.submitted = false;
        this.loading = false;
      },
      (error) => {
        this.toastService.show('Não foi possível enviar o contato! Tente novamente!', { type: 'danger' });
      }
    );
  }
}
